angular.module('gym.setup').factory('GymSetupService', ["$http", "$rootScope", "$q", function($http, $rootScope, $q) {
  var params;
  params = $rootScope.toParams;
  return {
    get: function() {
      var deferred, url;
      deferred = $q.defer();
      url = `gyms/${params.gymId}/setup/edit`;
      $http.get(url).then(function(gymTypes) {
        return deferred.resolve(gymTypes.data);
      });
      return deferred.promise;
    },
    set: function(gym_setup) {
      var url;
      url = `gyms/${params.gymId}/setup`;
      return $http.put(url, {
        gym_setup: gym_setup
      });
    }
  };
}]);
